import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useYandexMapApiStore = defineStore('yandexMapApi', () => {
    const isLoadScript = ref(false)

    function setLoadScript() {
        isLoadScript.value = true
    }

    return { isLoadScript, setLoadScript }
})